module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-ThinItalic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-ThinItalic-webfont.eot
// module id = 688
// module chunks = 0